module.exports = __webpack_public_path__ + "img/fcr.298d9850.svg";